var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 19.75C8.40032 19.7495 8.30174 19.7291 8.21002 19.69C8.0732 19.6341 7.95627 19.5385 7.87428 19.4155C7.7923 19.2925 7.74902 19.1478 7.75002 19V5.00003C7.75543 4.85772 7.80126 4.71989 7.88213 4.60266C7.96301 4.48544 8.07559 4.39366 8.2067 4.33807C8.33782 4.28247 8.48206 4.26536 8.62254 4.28873C8.76303 4.3121 8.89396 4.37499 9.00002 4.47003L16 11.47C16.1405 11.6107 16.2194 11.8013 16.2194 12C16.2194 12.1988 16.1405 12.3894 16 12.53L9.00002 19.53C8.86584 19.662 8.68797 19.7403 8.50002 19.75ZM9.25002 6.81003V17.19L14.44 12L9.25002 6.81003Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.454c155629f6c4fe1b7d1688082ed35f.svg";
export { ForwardRef as ReactComponent };